import { render, staticRenderFns } from "./PromoteEvent.vue?vue&type=template&id=2d796831&scoped=true&"
import script from "./PromoteEvent.vue?vue&type=script&lang=js&"
export * from "./PromoteEvent.vue?vue&type=script&lang=js&"
import style0 from "./PromoteEvent.vue?vue&type=style&index=0&id=2d796831&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d796831",
  null
  
)

export default component.exports